require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-marshall-white-open-magazine-paul-conrad.json") })
        }
      }, "path---journal-marshall-white-open-magazine-paul-conrad");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-marshall-white-open-magazine-paul-conrad!./.cache/json/journal-marshall-white-open-magazine-paul-conrad.json
// module id = 513
// module chunks = 231608221292675